import { Card } from '@radix-ui/themes'
import { Link } from '@remix-run/react'
import finish from '#app/images/finish-line.png'

const linkStyle = 'text-pink-400 underline font-bold text-lg'
export default function Welcome() {
	return (
		<Card className="w-full">
			<div className="flex flex-col gap-y-2">
				<div className="flex justify-center">
					<img src={finish} className="rounded-md" alt="" />
				</div>
				Marathon rank is a place that attempts to provide a ranking for every athlete that runs the
				marathon, and do so in a way that it encourages competition among all ages and both sexes.
				<p>
					Not only will you be able to see where you stand for your given classification (age &
					sex), you'll also be able to compare your results across groups since all results are also
					age and sex graded. Click the question mark in the top right for a clearer explanation of
					what this means.
				</p>
				<p>
					If this has piqued your curiousity, please{' '}
					<Link className={linkStyle} to="/select/search">
						search for an athlete
					</Link>
					,{' '}
					<Link className={linkStyle} to="/select/submit">
						see where a potential time would put you in the rankings
					</Link>
					, or{' '}
					<Link className={linkStyle} to="/leaderboard">
						check out the leaderboard
					</Link>
					.
				</p>
			</div>
		</Card>
	)
}
